export default __webpack_public_path__ + "e4eee23f904c7c83222a75aad8fab77d.png";